'use client';

import React from 'react';

interface ImageIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

export const ImageIcon: React.FC<ImageIconProps> = ({
  width = 20,
  height = 20,
  color = '#6e6e6e',
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 20"
      className={className}
    >
      <path
        fill={color}
        d="M4.196 1.875a2.324 2.324 0 0 0-2.321 2.321v11.608a2.324 2.324 0 0 0 2.321 2.321h11.608a2.324 2.324 0 0 0 2.321-2.321V4.196a2.324 2.324 0 0 0-2.321-2.321zm2.322 2.902a1.742 1.742 0 1 1-.001 3.483 1.742 1.742 0 0 1 0-3.483m5.223 4.062c.305 0 .584.16.744.417l3.192 5.224a.868.868 0 0 1-.744 1.324H5.067a.87.87 0 0 1-.773-.468.87.87 0 0 1 .058-.9l2.032-2.902a.87.87 0 0 1 .714-.37.87.87 0 0 1 .715.37l.957 1.371 2.228-3.645a.88.88 0 0 1 .743-.417z"
      />
    </svg>
  );
};

